import React, { Component } from 'react';
import { translate as t } from 'lang';
import './Forbidden.scss';

class Forbidden extends Component {

    render() {
        return (
            <div className="Forbidden">
                <div className="Forbidden-label">
                    {t('SORRY_YOU_CAN_NOT_BE_HERE')}
                </div>
            </div>
        );
    }
    
}

export default Forbidden;



// WEBPACK FOOTER //
// ./client/components/Forbidden/Forbidden.js